import { filterData, log } from '../../utils/helpers'
import moment from 'moment'
import CookiesStorageService from '../CookiesStorageService'

export const ListingParamsPayload = (entityName, page, limit, paging, filters, codePagination) => {
  log('ListingParamsPayload', entityName, page, limit, filters)
  let ListingParams = paging ?? (!!codePagination ? {
    'Pn': page,
    'Ps': limit
  } : {
    'pageNo': page,
    'pageSize': limit
  })
  // let newFilters = ListingParams
  // if (!!Object.keys(filters || {})?.length) {
  //   if (!!filters?.UUID) {
  //     newFilters['DocumentUUID'] = filters?.UUID
  //   }
  // }
  return { ...ListingParams, ...filterData(filters || {}) }
}

export const getActionSubmitPayload = (entityName, action, requestType, values) => {
  let data = { ...values }
  switch (entityName) {
    case 'codeUsageEdit':
      data = {
        ...values,
        'itemCode': `EG-${CookiesStorageService.getTaxpayerTRN()}-${values?.itemCode || ''}`,
        'activeFrom': values?.activeFrom ? moment(values?.activeFrom).locale('en-us').utc().format() : '',
        'activeTo': values?.activeTo ? moment(values?.activeTo).locale('en-us').utc().format() : ''
      }
      if (!!data?.linkedCode) {
        data.linkedCodeId = ''
      } else {
        data.linkedCode = ''
      }
      if (action === 'create') {
        data = { 'items': [filterData(data)] }
      }
      break
    case 'codesUsageCreate':
      if (action === 'create' && requestType === 'reuse') {
        data = { 'items': [filterData(data)] }
      }
      break

    case 'invoicePackages':
      if (action === 'create') {
        data = {
          type: values.type,
          format: values.format,
          representedTaxpayerFilterType: values.representedTaxpayerFilterType || '1',
          queryParameters: filterData({
            dateFrom: values?.dateFrom ? moment(values?.dateFrom).locale('en-us').startOf('day').utc().format() : '',
            dateTo: values?.dateTo ? moment(values?.dateTo).locale('en-us').endOf('day').utc().format() : '',
            documentTypeNames: values?.documentTypeNames || [],
            statuses: values?.statuses || [],
            receiverSenderType: values?.receiverSenderType || '',
            receiverSenderId: values?.receiverSenderId || '',
            branchNumber: values?.branchNumber || '',
            productsInternalCodes: values?.productsInternalCodes || [],
            itemCodes: values?.itemCodes?.length ? values?.itemCodes.map(item => ({
              codeValue: item?.codeLookupValue || '',
              codeType: item?.codeTypeNamePrimaryLang || ''
            })) : []
          })
        }
      }
      break
    default:
      break
  }
  return data
}

export const getApprovalCodeEditPayload = (values, isApproved) => {
  let data = { ...values }
  if (!!isApproved) {
    data = {
      ...values,
      'activeTo': values?.activeTo ? moment(values?.activeTo).locale('en-us').utc().format() : ''
    }
  } else {
    data = {
      ...values,
      'itemCode': `EG-${CookiesStorageService.getTaxpayerTRN()}-${values?.itemCode || ''}`,
      'activeFrom': values?.activeFrom ? moment(values?.activeFrom).locale('en-us').utc().format() : '',
      'activeTo': values?.activeTo ? moment(values?.activeTo).locale('en-us').utc().format() : ''
    }
  }
  if (!!data?.linkedCode) {
    data.linkedCodeId = ''
  } else {
    data.linkedCode = ''
  }
  return data
}